/**
 * DWEB-180 — the ONE header height, read back from the ONE declaration.
 *
 * The site scrolls three different ways and only one of them can see CSS:
 *
 *   the nav (13 call sites, utils/scrollToSection.js)  JS arithmetic — ignores CSS
 *   native fragment / scrollIntoView       honours scroll-padding-top on html
 *   antd scrollToFirstError                honours scroll-margin-top on the target
 *
 * So the value cannot live only in CSS, and it must not be copied into JS
 * either — a parallel constant is the same defect one file along, and this
 * release exists because that had already happened fifteen times at three
 * different values.
 *
 * It is therefore READ BACK from the custom property at call time. That also
 * makes it responsive for free: the media query in index.css switches the
 * value at 768px, and a call site asking during a resize gets the current one
 * rather than whatever was true at import.
 *
 * There is deliberately no numeric fallback. `--glass-bg`'s block in
 * index.css gives the reason: a fallback is the second copy, and it is the
 * copy that hides the failure. If the declaration ever goes missing this
 * returns 0, anchors land flush under the header, and
 * e2e/header-height.spec.js says so — visible, not silently almost-right.
 */

/** The declared header height in px, read from :root at call time. */
export function headerHeight() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return 0;
  const declared = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
  const px = parseFloat(declared);
  return Number.isFinite(px) ? px : 0;
}

/*
 * DWEB-229 retired `headerScrollOffset()`. It existed to negate this value for
 * react-scroll's `offset` prop, which counts UP from the target — and the nav
 * no longer calls react-scroll's animator, because that animator fixes its
 * destination at aim time (see utils/scrollToSection.js). The nav's one reader
 * is now `scrollToSection`, which subtracts `headerHeight()` directly, so there
 * is nothing left to negate. It is deleted rather than kept: an exported helper
 * with no consumer is a second declaration waiting for someone to use it.
 */
